import { handleRequest } from '@/utils';

export function handleJoinedQueue(session_id: string) {
  handleRequest('joinedQueue', {
    session_id,
    scene: 1,
  });
}
